import { useSortable } from '@dnd-kit/sortable';
import React from 'react';
import { CSS } from '@dnd-kit/utilities';
import { Button, Col, Form, InputNumber, Row } from 'antd';
import StationInput from '@/components/FormItems/StationInput';
import { ROW_GUTTER, VALIDATE_REQUIRED } from '@/config';
import { DeleteFilled, DragOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
type Props = {
  stopItem: { id: string };
  sourceCountryId: string;
  destinationCountryId: string;
  remove: (id: any) => void;
};

export default function SortableStopItem({ stopItem, sourceCountryId, destinationCountryId, remove }: Props) {
  const { t } = useTranslation();
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: stopItem.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  const ids = React.useMemo(() => {
    return [sourceCountryId, destinationCountryId].filter(x => x);
  }, [sourceCountryId, destinationCountryId]);
  return (
    <Row gutter={ROW_GUTTER} style={style}>
      <Col md={2} ref={setNodeRef} {...attributes} {...listeners} style={{ textAlign: 'center' }}>
        <Button icon={<DragOutlined />} type="text" />
      </Col>
      <Col md={8}>
        <Form.Item
          label={t('routesPage_StopName')}
          name={`routeStops[${stopItem.id}].stationId`}
          rules={[{ required: true, message: VALIDATE_REQUIRED }]}
        >
          <StationInput countryIds={ids} disabled={!sourceCountryId || !destinationCountryId} />
        </Form.Item>
      </Col>
      <Col md={12}>
        <Form.Item
          label={t('routesPage_DistanceFromSource')}
          name={`routeStops[${stopItem.id}].distanceFromSource`}
          rules={[{ required: true, message: VALIDATE_REQUIRED }]}
        >
          <InputNumber className="w-100" addonAfter={t('(Kms)')} min={0} />
        </Form.Item>
      </Col>

      <Col md={2} style={{ textAlign: 'right' }}>
        <Button
          icon={<DeleteFilled />}
          type="primary"
          danger
          onClick={() => {
            remove(stopItem.id);
          }}
        />
      </Col>
    </Row>
  );
}
